<div class="painel-principal">

        <!-- DADOS INICIAIS -->
        <mat-toolbar class="titulopartes" style="margin-bottom: 10px;">Dados Iniciais</mat-toolbar>
        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

            <!-- EMPRESAS -->
            <div ngModelGroup="comboEmpresa" fxFlex="35%" fxLayoutGap="20px" fxFlexOffset="20px"
                 class="marginCombo">
                <combo-pesquisavel #comboEmpresa 
                                    nome="empresa" 
                                    [itens]="empresas" 
                                    itemDescricao="nomeRazaoSocial"
                                    itemId="id"
                                    label="Empresa"
                                    [showDisplayId]="false" 
                                    [obrigatorio]="false"
                                    placeholder="Informe a empresa..."
                                    [(valor)]="movimentacoes.empresa"
                                    (valorChange)="onValorChange($event)">
                </combo-pesquisavel>
            </div>

            <!-- FORNECEDOR/COLABORADOR -->
            <div ngModelGroup="comboFornecedorColaborador" fxFlex="50%" fxLayoutGap="20px" fxFlexOffset="20px"
                 class="marginCombo">
                <combo-pesquisavel #comboFornecedorColaborador 
                                    nome="fornecedorColaborador" 
                                    [itens]="colaboradoresFornecesores" 
                                    itemDescricao="nome"
                                    itemId="cpf"
                                    label="Fornecedor/Colaborador"
                                    [showDisplayId]="true" 
                                    [showDisplayItemLabel]="true"
                                    itemLabel="tipo"
                                    [obrigatorio]="false"
                                    placeholder="Escolha..."
                                    [(valor)]="movimentacoes.fornecedorColaborador"
                                    (valorChange)="onValorFornecedorChange($event)">
                </combo-pesquisavel>
            </div>            

            <!-- TIPO MOVIMENTACAO -->
            <mat-form-field fxFlex="15%">
                <mat-label>Tipo de Movimentação</mat-label>
                <mat-select [(ngModel)]=movimentacoes.stTipoMovimentacao 
                            name="tiposMovimentacao" 
                            required
                            (selectionChange)="limparContaBancaria()">
                    <mat-option *ngFor="let i of tiposMovimentacao" [value]=i.id>
                        {{i.descricao}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </div>

        <div *ngIf="false">
            <mat-toolbar class="titulopartes">Conta Bancária</mat-toolbar>
            <div fxLayout="row" 
                fxLayoutGap="50px" 
                style="margin-top: 10px; margin-bottom: 10px" 
                fxFlexFill>
                <mat-form-field fxFlex="100%" fxFlexOffset="20px">
                    <mat-label>Agência - Conta Corrente</mat-label>
                    <mat-select name="contaBancaria" 
                                [(ngModel)]="movimentacoes.contaBancaria.id"
                                (selectionChange)="carregarContaBancaria()">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let m of contasBancarias" [value]="m.id">
                            Banco: {{m.banco.numero}} - {{m.banco.nome}} - Agência: {{m.numeroAgencia}} - Conta: {{m.numeroContaBancaria}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        

        <div fxLayout="row" fxLayoutGap="50px" fxFlexFill>

            <!-- DESCRICAO -->
            <mat-form-field fxFlexOffset="20px" fxFlex="100%" appearance="outline">
                <mat-label>Descrição:</mat-label>
                <textarea [(ngModel)]=movimentacoes.descricaoMovimentacao matInput #message name="descricao" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="3" maxlength="200">
                </textarea>
                <mat-hint align="end">{{message.value.length}} / 200</mat-hint>
            </mat-form-field>
        </div>
        
        <!-- DOCUMENTOS -->
        <mat-toolbar class="titulopartes">Documentos</mat-toolbar>
        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

            <!-- NR DOCUMENTOS -->
            <mat-form-field fxFlexOffset="20px" fxFlex="18%">
                <input [(ngModel)]=movimentacoes.nrDocumento 
                       #numeroDocumento 
                       matInput maxlength="20" 
                       name="numeroDocumento" 
                       placeholder="Número documento:">
                <mat-hint align="end">{{numeroDocumento.value.length}} / 20</mat-hint>
            </mat-form-field>

            <!-- DATA DOCUMENTOS -->
            <mat-form-field fxFlex="18%">
                <input matInput [(ngModel)]=movimentacoes.dataDocumento 
                      (input)="onMascaraDataInput($event)" 
                       name="dataDocumento" [matDatepicker]="dataDocumento" 
                       placeholder="Data do documento:">
                <mat-datepicker-toggle matSuffix [for]="dataDocumento">
                </mat-datepicker-toggle>
                <mat-datepicker #dataDocumento></mat-datepicker>
            </mat-form-field>

            <!-- VALOR -->
            <mat-form-field fxFlex="15%">
                <input [(ngModel)]=movimentacoes.valorMovimentacao 
                       currencyMask name="valorMovimentacao" 
                       placeholder="Valor do movimento" 
                       #valorMovimentacao
                       (blur)="validarValorDodumento(valorMovimentacao.value)"
                       matInput maxlength="13"
                       [options]="{ prefix: '', thousands: '.', decimal: ',' }" />
                <span matPrefix>R$&nbsp;</span>
            </mat-form-field>
        </div>

        <!-- OUTRAS INFORMACOES -->
        <mat-toolbar class="titulopartes">Outras Informações</mat-toolbar>
        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
            <mat-form-field fxFlex="25%" fxLayoutGap="20px" fxFlexOffset="20px">
                <mat-label>Unidade</mat-label>
                <mat-select [(ngModel)]=movimentacoes.unidade.idUnidade name="unidade" required>
                    <mat-option></mat-option>
                    <mat-option *ngFor="let i of unidades" [value]=i.idUnidade>
                        {{i.nomeUnidade}}
                    </mat-option>
                </mat-select>
                <mat-hint *ngIf="unidades?.length === 0" align="start">Nenhuma unidade cadastrado</mat-hint>
            </mat-form-field>

            <mat-form-field fxFlex="30%" fxLayoutGap="20px" fxFlexOffset="20px">
                <mat-label>Departamento</mat-label>
                <mat-select [(ngModel)]=movimentacoes.departamento.idDepartamento name="departamento">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let i of departamentos" [value]=i.idDepartamento>
                        {{i.nmDepartamento}}
                    </mat-option>
                </mat-select>
                <mat-hint *ngIf="departamentos?.length === 0" align="start">Nenhum departamento cadastrado</mat-hint>
            </mat-form-field>

            <mat-form-field fxFlex="45%" fxLayoutGap="20px" fxFlexOffset="20px">
                <mat-label>Doadores</mat-label>
                <mat-select [(ngModel)]=movimentacoes.doador.id name="doadores">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let i of doadores" [value]="getIdDoador(i)">
                        {{getDescricaoDoador(i)}}
                    </mat-option>
                </mat-select>
                <mat-hint *ngIf="doadores?.length === 0" align="start">Nenhum doador cadastrado</mat-hint>
            </mat-form-field>
        </div>


        <mat-toolbar class="titulopartes">Tributos</mat-toolbar>
        <div fxLayout="column" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px;" fxFlexFill>
            <div fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px" ngModelGroup="grupoTributo">
                <div *ngFor="let tributo of movimentacoes.tributos; let index = index">
                    <formulario-tributo [tributoMovimentacao]="tributo" 
                                        [index]="index"
                                        [tributosMovimentacao]="movimentacoes.tributos"  
                                        [tributos]="tributos" 
                                        [perfilAcesso]="perfilAcesso"
                                        [faturas]="movimentacoes.faturas">
                    </formulario-tributo>
                </div>
                <div *ngIf="perfilAcesso.insere" fxLayoutAlign="start center" 
                     fxLayoutGap="16px" 
                     style="padding-top: 6px; padding-left: 20px; padding-bottom: 10px;">
                    <div>
                        <button matTooltip="Novo" mat-mini-fab color="primary" (click)="addTributo()">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                </div>                
            </div>
        </div>

        <mat-toolbar class="titulopartes">
            <span>Rateio entre Projetos</span>
            <!-- 
                <span style="font-weight: 800; padding-left: 10px;" [style.color]="valorRateioSuperior && movimentacoes.rateios.length > 0 ? 'red' : 'green'">(Total: {{getValorTotalRateio()}})</span>
                <span *ngIf="valorRateioSuperior && movimentacoes.rateios.length > 0" style="color: orangered; padding-left: 10px;">ATENÇÃO !!! O valor do rateio está diferente ao valor do movimento.</span>
             -->
        </mat-toolbar>
        <div fxLayout="column" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px;" fxFlexFill>
            <div fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px" ngModelGroup="grupoRateio">
                <div *ngFor="let rateio of movimentacoes.rateios; let index = index">
                    <formulario-rateio [rateio]="rateio" 
                                       [index]="index"
                                       [rateios]="movimentacoes.rateios"   
                                       [perfilAcesso]="perfilAcesso">
                    </formulario-rateio>
                </div>
                <div *ngIf="perfilAcesso.insere" fxLayoutAlign="start center" fxLayoutGap="16px" style="padding-top: 10px; padding-left: 20px;">
                    <div>
                        <button matTooltip="Novo" mat-mini-fab color="primary" (click)="addRateio()">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                </div>                
            </div>
        </div>


        <mat-toolbar class="titulopartes" style="margin-top: 20px;">
            <span>Rateio entre Unidades</span>
            <span style="font-weight: 800; padding-left: 10px;" [style.color]="valorRateioUnidadeSuperior && movimentacoes.rateiosUnidades.length > 0 ? 'red' : 'green'">(Total: {{getValorTotalRateioUnidades()}})</span>
            <span *ngIf="valorRateioUnidadeSuperior && movimentacoes.rateiosUnidades.length > 0" style="color: orangered; padding-left: 10px;">ATENÇÃO !!! O valor do rateio das unidades está diferente ao valor do movimento.</span>
        </mat-toolbar>
        <div fxLayout="column" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
            <div fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px" ngModelGroup="grupoRateioUnidade">
                <div *ngFor="let rateio of movimentacoes.rateiosUnidades; let index = index">
                    <formulario-rateio-unidade [rateio]="rateio" 
                                               [index]="index"
                                               [rateios]="movimentacoes.rateiosUnidades"   
                                               [perfilAcesso]="perfilAcesso" 
                                               [unidades]="unidades">
                    </formulario-rateio-unidade>
                </div>
                <div *ngIf="perfilAcesso.insere" fxLayoutAlign="start center" fxLayoutGap="16px" style="padding-top: 10px; padding-left: 20px;">
                    <div>
                        <button matTooltip="Novo" mat-mini-fab color="primary" (click)="addRateioUnidade()">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                </div>                
            </div>
        </div>

</div>
